import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import styles from './index.module.scss';
import { makeStyles } from '@material-ui/core';

const useAutoCompeleteStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#00A15D',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#00A15D',
      borderWidth: '2px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#00A15D',
    }
  }
})

export default function Tags({ title, optionsData = [], onChange, choosed }) {
  return (
    <div className={styles.autocomplete}>
      <Autocomplete
        classes={useAutoCompeleteStyles()}
        options={optionsData}
        noOptionsText={!choosed && !optionsData.length ? "尚無資料" : "請清除目前選項後重新選取"}
        getOptionLabel={(option) => option.label}
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            label={title}
          />
        )}
      />
    </div>
  );
}
